import { notifyViewLoading } from 'tabview/actions';
import { action$, extractPayload, ofType, withNamespace } from '@ardoq/rxbeach';
import { distinctUntilChanged, map } from 'rxjs/operators';

export const getIsViewBusy$ = (currentViewInstanceId: string) =>
  action$.pipe(
    withNamespace(currentViewInstanceId),
    ofType(notifyViewLoading),
    extractPayload(),
    map(({ isBusy }) => isBusy),
    distinctUntilChanged()
  );
